import { useContext, createContext, ReactNode } from 'react';

import { HomepageV4 } from 'generatedBfw/static';

const HomepageContext = createContext<HomepageV4 | null>(null);

interface Props {
  children: ReactNode;
  value: HomepageV4;
}

export const HomepageContextProvider = ({ children, value }: Props) => (
  <HomepageContext.Provider value={value}>{children}</HomepageContext.Provider>
);

const useHomepageContext = () => {
  const currentHomepageContext = useContext(HomepageContext);

  if (!currentHomepageContext) {
    throw new Error('useHomepageContext has to be used within <HomepageContextProvider>');
  }

  return currentHomepageContext;
};

export default useHomepageContext;
